export const ADD_ITEM = '@NOTIFICATIONS/ADD_ITEM';
export const ADD_ITEMS = '@NOTIFICATIONS/ADD_ITEMS';
export const DELETE_ITEM = '@NOTIFICATIONS/DELETE_ITEM';
export const DELETE_ITEMS = '@NOTIFICATIONS/DELETE_ITEMS';
